module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "plm_hd"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/REV_contents"
    }
  }, [_vm._v("The structure of the drama")])]), _vm._v(" "), _c('h4', {
    staticClass: "struct_hd1"
  }, [_vm._v("The prologue (1:1–8)")]), _vm._v(" "), _c('h5', {
    staticClass: "struct_hd2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/REV_ch01#str002"
    }
  }, [_vm._v("The relevance of the book of Revelation")])]), _vm._v(" "), _c('h6', {
    staticClass: "struct_num"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/REV_ch01#str003"
    }
  }, [_vm._v("1. The title (1:1–3)")])]), _vm._v(" "), _c('h6', {
    staticClass: "struct_num"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/REV_ch01#str004"
    }
  }, [_vm._v("2. The greeting (1:4–8)")])]), _vm._v(" "), _c('h4', {
    staticClass: "struct_hd1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Scene 1: The church in the world: ")]), _c('span', {
    staticClass: "bolditalic"
  }, [_vm._v("seven letters dictated")]), _c('span', {
    staticClass: "bold"
  }, [_vm._v(" (1:9 – 3:22)")])]), _vm._v(" "), _c('h5', {
    staticClass: "struct_hd2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_ch02#str005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The repeat of patterns")])]), _vm._v(" "), _c('h6', {
    staticClass: "struct_num"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_ch02#str006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Scene 1 opens: the church centred on Christ (1:9–20)")])]), _vm._v(" "), _c('h6', {
    staticClass: "struct_num"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_ch02#str007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. The first letter: to Ephesus (2:1–7)")])]), _vm._v(" "), _c('h6', {
    staticClass: "struct_num"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_ch02#str008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. The second letter: to Smyrna (2:8–11)")])]), _vm._v(" "), _c('h6', {
    staticClass: "struct_num"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_ch02#str009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. The third letter: to Pergamum (2:12–17)")])]), _vm._v(" "), _c('h6', {
    staticClass: "struct_num"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_ch02#str010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. The fourth letter: to Thyatira (2:18–29)")])]), _vm._v(" "), _c('h6', {
    staticClass: "struct_num"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_ch02#str011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. The fifth letter: to Sardis (3:1–6)")])]), _vm._v(" "), _c('h6', {
    staticClass: "struct_num"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_ch02#str012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. The sixth letter: to Philadelphia (3:7–13)")])]), _vm._v(" "), _c('h6', {
    staticClass: "struct_num"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_ch02#str013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. The seventh letter: to Laodicea (3:14–22)")])]), _vm._v(" "), _c('h4', {
    staticClass: "struct_hd1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Scene 2: Suffering for the church: ")]), _c('span', {
    staticClass: "bolditalic"
  }, [_vm._v("seven seals opened")]), _c('span', {
    staticClass: "bold"
  }, [_vm._v(" (4:1 – 8:1)")])]), _vm._v(" "), _c('h5', {
    staticClass: "struct_hd2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_ch03#str014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The meaning of numbers")])]), _vm._v(" "), _c('h6', {
    staticClass: "struct_num"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_ch03#str015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Scene 2 opens: creation centred on Christ (4:1 – 5:14)")])]), _vm._v(" "), _c('h6', {
    staticClass: "struct_num"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_ch03#str016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. The first seal: conquest (6:1–2)")])]), _vm._v(" "), _c('h6', {
    staticClass: "struct_num"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_ch03#str017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. The second seal: strife (6:3–4)")])]), _vm._v(" "), _c('h6', {
    staticClass: "struct_num"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_ch03#str018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. The third seal: scarcity (6:5–6)")])]), _vm._v(" "), _c('h6', {
    staticClass: "struct_num"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_ch03#str019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. The fourth seal: death (6:7–8)")])]), _vm._v(" "), _c('h6', {
    staticClass: "struct_num"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_ch03#str020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. The fifth seal: the suffering of God’s witnesses (6:9–11)")])]), _vm._v(" "), _c('h6', {
    staticClass: "struct_num"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_ch03#str021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. The sixth seal: the final cataclysm (6:12–17)")])]), _vm._v(" "), _c('h6', {
    staticClass: "struct_num"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_ch03#str022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Yet the church is indestructible (7:1–17)")])]), _vm._v(" "), _c('h6', {
    staticClass: "struct_num"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_ch03#str023",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. The seventh seal: ‘The rest is silence’ (8:1)")])]), _vm._v(" "), _c('h4', {
    staticClass: "struct_hd1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Scene 3: Warning for the world: ")]), _c('span', {
    staticClass: "bolditalic"
  }, [_vm._v("seven trumpets sounded")]), _c('span', {
    staticClass: "bold"
  }, [_vm._v(" (8:2 – 11:18)")])]), _vm._v(" "), _c('h5', {
    staticClass: "struct_hd2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_ch04#str024",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The sequence of events")])]), _vm._v(" "), _c('h6', {
    staticClass: "struct_num"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_ch04#str025",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Scene 3 opens: God hears his people’s cry (8:2–6)")])]), _vm._v(" "), _c('h6', {
    staticClass: "struct_num"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_ch04#str026",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. The first trumpet: the earth stricken (8:7)")])]), _vm._v(" "), _c('h6', {
    staticClass: "struct_num"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_ch04#str027",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. The second trumpet: the sea stricken (8:8–9)")])]), _vm._v(" "), _c('h6', {
    staticClass: "struct_num"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_ch04#str028",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. The third trumpet: the rivers stricken (8:10–11)")])]), _vm._v(" "), _c('h6', {
    staticClass: "struct_num"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_ch04#str029",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. The fourth trumpet: the sky stricken (8:12)")])]), _vm._v(" "), _c('h6', {
    staticClass: "struct_num"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_ch04#str030",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Let people beware the remaining trumpets! (8:13)")])]), _vm._v(" "), _c('h6', {
    staticClass: "struct_num"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_ch04#str031",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. The fifth trumpet: torment (9:1–12)")])]), _vm._v(" "), _c('h6', {
    staticClass: "struct_num"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_ch04#str032",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. The sixth trumpet: destruction (9:13–21)")])]), _vm._v(" "), _c('h6', {
    staticClass: "struct_num"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_ch04#str033",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. The meaning of the last trumpet (10:1–7)")])]), _vm._v(" "), _c('h6', {
    staticClass: "struct_num"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_ch04#str034",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. Yet the world is unrepentant (10:8 – 11:14)")])]), _vm._v(" "), _c('h6', {
    staticClass: "struct_num"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_ch04#str035",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. The seventh trumpet: the world is no more (11:15–18)")])]), _vm._v(" "), _c('h4', {
    staticClass: "struct_hd1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Scene 4: The drama of history: ")]), _c('span', {
    staticClass: "bolditalic"
  }, [_vm._v("seven visions of cosmic conflict")]), _c('span', {
    staticClass: "bold"
  }, [_vm._v(" (11:19 – 15:4)")])]), _vm._v(" "), _c('h5', {
    staticClass: "struct_hd2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_ch05#str036",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The analysis of the drama")])]), _vm._v(" "), _c('h6', {
    staticClass: "struct_num"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_ch05#str037",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Scene 4 opens: behind the veil, God’s covenant (11:19)")])]), _vm._v(" "), _c('h6', {
    staticClass: "struct_num"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_ch05#str038",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. The characters (12:1–6)")])]), _vm._v(" "), _c('h6', {
    staticClass: "struct_num"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_ch05#str039",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. The plot (12:7–16)")])]), _vm._v(" "), _c('h6', {
    staticClass: "struct_num"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_ch05#str040",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. The prelude (12:17)")])]), _vm._v(" "), _c('h6', {
    staticClass: "struct_num"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_ch05#str041",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. The first vision: the beast from the sea (13:1–10)")])]), _vm._v(" "), _c('h6', {
    staticClass: "struct_num"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_ch05#str042",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. The second vision: the beast from the earth (13:11–17)")])]), _vm._v(" "), _c('h6', {
    staticClass: "struct_num"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_ch05#str043",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. The number of the beast (13:18)")])]), _vm._v(" "), _c('h6', {
    staticClass: "struct_num"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_ch05#str044",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. The third vision: the Lamb and his followers (14:1–5)")])]), _vm._v(" "), _c('h6', {
    staticClass: "struct_num"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_ch05#str045",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. The fourth vision: the angels of grace, doom and warning (14:6–13)")])]), _vm._v(" "), _c('h6', {
    staticClass: "struct_num"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_ch05#str046",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. The fifth vision: the final reaping (14:14–20)")])]), _vm._v(" "), _c('h6', {
    staticClass: "struct_num"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_ch05#str047",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. The sixth vision: a preview of Scene 5 (15:1)")])]), _vm._v(" "), _c('h6', {
    staticClass: "struct_num"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_ch05#str048",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. The seventh vision: the song of victory (15:2–4)")])]), _vm._v(" "), _c('h4', {
    staticClass: "struct_hd1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Scene 5: Punishment for the world: ")]), _c('span', {
    staticClass: "bolditalic"
  }, [_vm._v("seven bowls poured out")]), _c('span', {
    staticClass: "bold"
  }, [_vm._v(" (15:5 – 16:21)")])]), _vm._v(" "), _c('h5', {
    staticClass: "struct_hd2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_ch06#str049",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The unity of the drama")])]), _vm._v(" "), _c('h6', {
    staticClass: "struct_num"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_ch06#str050",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Scene 5 opens: behind the veil, God’s inescapable wrath (15:5 – 16:1)")])]), _vm._v(" "), _c('h6', {
    staticClass: "struct_num"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_ch06#str051",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. The first bowl: the earth stricken (16:2)")])]), _vm._v(" "), _c('h6', {
    staticClass: "struct_num"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_ch06#str052",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. The second bowl: the sea stricken (16:3)")])]), _vm._v(" "), _c('h6', {
    staticClass: "struct_num"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_ch06#str053",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. The third bowl: the rivers stricken (16:4–7)")])]), _vm._v(" "), _c('h6', {
    staticClass: "struct_num"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_ch06#str054",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. The fourth bowl: the sky stricken (16:8–9)")])]), _vm._v(" "), _c('h6', {
    staticClass: "struct_num"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_ch06#str055",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. The fifth bowl: torment (16:10–11)")])]), _vm._v(" "), _c('h6', {
    staticClass: "struct_num"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_ch06#str056",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. The sixth bowl: destruction (16:12–16)")])]), _vm._v(" "), _c('h6', {
    staticClass: "struct_num"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_ch06#str057",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. The seventh bowl: the world is no more (16:17–21)")])]), _vm._v(" "), _c('h4', {
    staticClass: "struct_hd1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Scene 6: Babylon the whore: ")]), _c('span', {
    staticClass: "bolditalic"
  }, [_vm._v("seven words of justice")]), _c('span', {
    staticClass: "bold"
  }, [_vm._v(" (17:1 – 19:10)")])]), _vm._v(" "), _c('h5', {
    staticClass: "struct_hd2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_ch07#str058",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The identifying of symbols")])]), _vm._v(" "), _c('h6', {
    staticClass: "struct_num"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_ch07#str059",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Scene 6 opens: the first word about Babylon (17:1–6)")])]), _vm._v(" "), _c('h6', {
    staticClass: "struct_num"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_ch07#str060",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. The second word: the mystery of Babylon (17:7–18)")])]), _vm._v(" "), _c('h6', {
    staticClass: "struct_num"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_ch07#str061",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. The third word: the fall of Babylon (18:1–3)")])]), _vm._v(" "), _c('h6', {
    staticClass: "struct_num"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_ch07#str062",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. The fourth word: the judgment of Babylon (18:4–20)")])]), _vm._v(" "), _c('h6', {
    staticClass: "struct_num"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_ch07#str063",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. The fifth word: the death of Babylon (18:21–24)")])]), _vm._v(" "), _c('h6', {
    staticClass: "struct_num"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_ch07#str064",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. The sixth word: the doom song of Babylon (19:1–5)")])]), _vm._v(" "), _c('h6', {
    staticClass: "struct_num"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_ch07#str065",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. The seventh word: the successor of Babylon (19:6–8)")])]), _vm._v(" "), _c('h6', {
    staticClass: "struct_num"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_ch07#str066",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. These are true words of God (19:9–10)")])]), _vm._v(" "), _c('h4', {
    staticClass: "struct_hd1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Scene 7: The drama behind history: ")]), _c('span', {
    staticClass: "bolditalic"
  }, [_vm._v("seven visions of ultimate")]), _c('span', {
    staticClass: "bold"
  }), _c('span', {
    staticClass: "bolditalic"
  }, [_vm._v("reality")]), _c('span', {
    staticClass: "bold"
  }, [_vm._v(" (19:11 – 21:8)")])]), _vm._v(" "), _c('h5', {
    staticClass: "struct_hd2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_ch08#str067",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The millennium")])]), _vm._v(" "), _c('h6', {
    staticClass: "struct_num"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_ch08#str068",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Scene 7 opens: the first vision: the Captain of the armies of heaven (19:11–16)")])]), _vm._v(" "), _c('h6', {
    staticClass: "struct_num"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_ch08#str069",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. The second vision: his victory is sure (19:17–18)")])]), _vm._v(" "), _c('h6', {
    staticClass: "struct_num"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_ch08#str070",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. The third vision: his enemies are doomed (19:19–21)")])]), _vm._v(" "), _c('h6', {
    staticClass: "struct_num"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_ch08#str071",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. The fourth vision: the devil (20:1–3)")])]), _vm._v(" "), _c('h6', {
    staticClass: "struct_num"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_ch08#str072",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. The fifth vision: the church (20:4–10)")])]), _vm._v(" "), _c('h6', {
    staticClass: "struct_num"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_ch08#str073",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. The sixth vision: the last judgment (20:11–15)")])]), _vm._v(" "), _c('h6', {
    staticClass: "struct_num"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_ch08#str074",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. The seventh vision: the new age (21:1–8)")])]), _vm._v(" "), _c('h4', {
    staticClass: "struct_hd1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Scene 8: Jerusalem the bride: ")]), _c('span', {
    staticClass: "bolditalic"
  }, [_vm._v("seven final revelations")]), _c('span', {
    staticClass: "bold"
  }, [_vm._v(" (21:9 – 22:19)")])]), _vm._v(" "), _c('h6', {
    staticClass: "struct_num"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_ch09#str075",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Scene 8 opens (21:9)")])]), _vm._v(" "), _c('h6', {
    staticClass: "struct_num"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_ch09#str076",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. The first revelation: God’s city (21:10–21)")])]), _vm._v(" "), _c('h6', {
    staticClass: "struct_num"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_ch09#str077",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. The second revelation: God’s dwelling (21:22–27)")])]), _vm._v(" "), _c('h6', {
    staticClass: "struct_num"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_ch09#str078",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. The third revelation: God’s world renewed (22:1–5)")])]), _vm._v(" "), _c('h6', {
    staticClass: "struct_num"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_ch09#str079",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. The fourth revelation: God’s word validated (22:6–10)")])]), _vm._v(" "), _c('h6', {
    staticClass: "struct_num"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_ch09#str080",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. The fifth revelation: God’s work completed (22:11–15)")])]), _vm._v(" "), _c('h6', {
    staticClass: "struct_num"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_ch09#str081",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. The sixth revelation: God’s final blessing (22:16–17)")])]), _vm._v(" "), _c('h6', {
    staticClass: "struct_num"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_ch09#str082",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. The seventh revelation: God’s final curse (22:18–19)")])]), _vm._v(" "), _c('h4', {
    staticClass: "struct_hd1"
  }, [_vm._v("The epilogue (22:20–21)")]), _vm._v(" "), _c('h5', {
    staticClass: "struct_hd2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_ch10#str083",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The book we could do without")])])]), _vm._v(" "), _c('h5', {
    staticClass: "struct_hd3 sigil_not_in_toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/REV_ch10#str084",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The author’s last word (22:20–21)")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7991f967","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/REV_structure.vue
// module id = 78
// module chunks = 0